import { useContext } from 'react';
import { InterfaceContext } from 'src/contexts/InterfaceContext';

const useInterface = () => {
	return useContext(InterfaceContext);
};

export default useInterface;
